import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 7.63c.34 0 .617.276.617.617v6.016l2.7-2.7a.617.617 0 1 1 .873.873l-3.754 3.754a.617.617 0 0 1-.873 0L7.81 12.436a.617.617 0 0 1 .873-.873l2.7 2.7V8.247c0-.341.276-.617.617-.617Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-8.765a8.765 8.765 0 1 0 0 17.53 8.765 8.765 0 0 0 0-17.53Z"
      clip-rule="evenodd"
    />
  </svg>
`;
